import React from 'react';
import {t} from '@lingui/core/macro';

interface IBatchOperationSummaryProps {
    selectedLabel: string,
    selectedCount: number,
    actionLabel?: string,
}

const BatchOperationSummary: React.FC<IBatchOperationSummaryProps> = ({selectedLabel, selectedCount, actionLabel}) => (
    <>
        <p className="text-medium">{selectedLabel}: {selectedCount}</p>
        <p className="text-medium">{t`Операция`}: {actionLabel}</p>
    </>
);

export default BatchOperationSummary;
